import Vuex from "vuex"
import kirchgeld from './kirchgeld'
import commonStore from '@/modules/common/store'

export default new Vuex.Store({
  state: () => {
    return {
      ...commonStore.state(),
    }
  },
  modules: {
    kirchgeld,
  },
  actions: {
    ...commonStore.actions,
  },
  mutations: {
    ...commonStore.mutations,
  }
})
